import { Component, OnInit, Inject} from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../app/modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ManageEquipmentService } from '../../../manage-equipment/manage-equipment.service';
import { EquipmentActionHistory, UpdateActionHistoryRequest } from '../../../manage-equipment/models/manage-equipment.model';
import { CryptoService } from '../../../../services/crypto.service';
import { DatePipe } from '@angular/common';
import { ActionService } from '../../../action/action.service.service';
import { NotificationsService } from 'angular2-notifications';
import { ConfirmationBoxComponent } from '../../../../shared/confirmation-box/confirmation-box.component';


@Component({
  selector: 'app-action-edit',
  templateUrl: './action-edit.component.html',
  styleUrls: ['./action-edit.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class ActionEditComponent implements OnInit {

  loading: boolean;
  equipmentId: number;
  actionId: number;
  actionDateNew: Date;
  actionDateStr: string;
  actionDate: Date;
  actionSMUNew: number;
  actionSMU: number;
   actionPMU: number;
  distanceForward: number;
  distanceReverse: number;
  enableDistTravelledTracking: boolean;
  totalDistance: number;
  warning: string;
  ShowWarning: boolean;
  actionHistoryList: EquipmentActionHistory[];
  selectAll: boolean = true;
showPropelHrsPerc: boolean; 
NewPropel:number;
  constructor(
    public _dialogRef: MatDialogRef<ActionEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _equipmentService: ManageEquipmentService,
    private crypto: CryptoService,
    private _actionService: ActionService,
    private datePipe: DatePipe,
    private _notify: NotificationsService,
    public _dialog: MatDialog
  ) {

  }

  ngOnInit() {
    this.equipmentId = this.data.equipmentId;
    this.actionId = this.data.actionId;
    this.actionDate = this.parseDate(this.data.actionDate);
    this.actionDateNew = this.parseDate(this.data.actionDate);
    this.actionDateStr = this.datePipe.transform(this.actionDate, 'dd MMM yyyy')
    this.actionSMU = this.data.actionSMU;
    this.actionSMUNew = this.data.actionSMU;
    this.enableDistTravelledTracking = this.data.enableDistTravelledTracking;
    this.showPropelHrsPerc = this.data.ShowPropelHrsPerc;
     this.actionPMU = this.data.actionPMU;
    console.log("this.data,:", this.data, this.actionDateNew);
    this.getHistoryToEdit();
  }

  getHistoryToEdit() {
    this._equipmentService.getEquipmentActionHistoryToEdit(this.equipmentId, this.actionId, this.actionSMU, this.datePipe.transform(this.actionDate, 'MM/dd/yyyy')).subscribe(history => {
      history.map(m => {
        if (m.entry_user_name && m.entry_user_name.length > 0) {
          m.entry_user_name = this.crypto.decrypt(m.entry_user_name);
          m.selected = true;
        }
      });
      this.actionHistoryList = history;
      this.distanceForward = this.actionHistoryList?.[0]?.DistanceForward;
      this.distanceReverse = this.actionHistoryList?.[0]?.DistanceReverse;
      this.calculateTotal();
    });
  }


  parseDate(dateStr: string): Date {
    if (!dateStr) return null;
    // Expected format: '15/Apr/2025'
    const [day, mon, year] = dateStr.split('/');
    return new Date(`${mon} ${day}, ${year}`);
  }

  calculateTotal() {
    const forward = Number(this.distanceForward) || 0;
    const reverse = Number(this.distanceReverse) || 0;
    this.totalDistance = forward + reverse;
  }


  ChecklastInspectionDateAndSMU() {
    this.loading = true;
    var newActionDate = new Date(this.actionDate);
    if (newActionDate != null && this.actionSMU != null) {
      this._actionService.CheckValidationForAction(this.equipmentId, this.actionDate, this.actionSMU).subscribe(res => {
        if (res != "") {
          this.ShowWarning = true;
          this.warning = res;
          this.loading = false;
        } else {
          this.ShowWarning = false;
          this.warning = res;
          this.loading = false;
          //if (this.NewSMU < this.equipmentDetails.LastInspectionSMU && this.lastInspectionDate > this.newActionDate) {
          //  this.OpenConfirmDialog()
          //} else {
          //  this.loadSystemIds().subscribe(() => {

          //  });
          //}
        }
      })
    }
  }


  UpdateAction() {
    const dialogRef = this._dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        title: 'Confirm Update',
        message: 'Are you sure you want to proceed with updating the action details?',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        const request: UpdateActionHistoryRequest = {
          equipmentId: this.equipmentId,
          actionIds: this.actionHistoryList.map(x => x.history_id).filter(id => id != null).join(','),
          actionDate: this.actionDateStr,
          actionSMU: this.actionSMU,
          actionDateNew: this.datePipe.transform(this.actionDateNew, 'dd MMM yyyy'),
          actionSMUNew: this.actionSMUNew,
          distanceForward: this.distanceForward,
          distanceReverse: this.distanceReverse,
          allSelected: false,
          actionPMU: this.actionPMU
        };
        if (request.actionDate != request.actionDateNew || request.actionSMU != request.actionSMUNew) {
          this.loading = true;
          this._equipmentService.updateEquipmentActionHistory(request).subscribe({
            next: (res) => {
              if (res?.Status === 1) {
                this._notify.success(res.Message);
                this._dialogRef.close(true);
                this.loading = false;
              }
              else {
                this._notify.error(res.Message);
                this.loading = false;
              }
            },
            error: (err) => {
              this._notify.error('Something went wrong while updating.');
              console.error(err);
              this.loading = false;
            },
          });
        }
      }
      else
        this.loading = false;
    });
  }

  rollbackEquipmentAction() {
    const dialogRef = this._dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        title: 'Confirm Rollback',
        message: 'Are you sure you want to rollback these actions?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        const request: UpdateActionHistoryRequest = {
          equipmentId: this.equipmentId,
          actionIds: this.actionHistoryList.filter(x => x.selected).map(x => x.history_id).filter(id => id != null).join(','),
          actionDate: this.actionDateStr,
          actionSMU: this.actionSMU,
          actionDateNew: '',
          actionSMUNew: 0,
          distanceForward: 0,
          distanceReverse: 0,
          allSelected: this.selectAll,
          actionPMU: this.actionPMU
        };
        this.loading = true;
          this._equipmentService.rollbackEquipmentAction(request).subscribe({
            next: (res) => {
              if (res?.Status === 1) {
                this._notify.success(res.Message);
                this._dialogRef.close(true);
                this.loading = false;
              }
              else {
                this._notify.error(res.Message);
                this.loading = false;
              }
            },
            error: (err) => {
              this._notify.error('Something went wrong while updating.');
              console.error(err);
              this.loading = false;
            },
          });
      }
      else
        this.loading = false;
    });


    
      
  }
   

  onCloseClick(): void {
    this._dialogRef.close(false);
  }



  toggleSelectAll(isChecked: boolean) {
    this.actionHistoryList.forEach((item: any) => {
      item.selected = isChecked;
    });
  }

  checkIfAllSelected() {
    this.selectAll = this.actionHistoryList.every((item: any) => item.selected);
  }


}
